module.exports = __webpack_public_path__ + "media/src/assets/Images/Calendar-766ed1bc71de67d492756f48631f2898.svg";